// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__LtlvZ","image":"Signup_image__8585c","login":"Signup_login__+dLbl"};